module.exports = __webpack_public_path__ + "static/media/andes-1280.4e66045f.webp";